import React, { Component } from 'react';
import PropTypes from 'prop-types';

// External Dependencies
import Button from 'material-ui-next/Button';
import Dialog, {
  DialogActions,
  DialogTitle,
} from 'material-ui-next/Dialog';

// Internal Dependencies
import connectComponent from '../../../connect-component';
import NinjaInfoForm from './ninja-info-form';
import {
  addOrUpdateNinja,
  dialogForm,
  dialogClose,
} from '../../../state/ui/update-ninjas/add-ninja-dialog/actions';

const dialogStyles = {
  minWidth: 700,
};

const dialogTitleStyles = {
  paddingBotom: 0,
};

class DialogAddNinja extends Component {
  static propTypes = {
    id: PropTypes.number,
    isOpen: PropTypes.bool,
    onAddOrUpdateNinja: PropTypes.func,
    updateDialogForm: PropTypes.func,
    closeDialog: PropTypes.func,
  }

  static defaultProps = {
    id: null,
    isOpen: false,
    onAddOrUpdateNinja: null,
    updateDialogForm: null,
    closeDialog: null,
  };

  handleClose = (e) => {
    e.stopPropagation();
    Promise.all([
      this.props.closeDialog(),
      this.props.updateDialogForm({}),
    ]);
  }

  render() {
    const {
      id,
      isOpen,
      onAddOrUpdateNinja,
    } = this.props;
    const dialogTitle = `${id ? 'Update' : 'Add'} Ninja`;
    return (
      <div style={dialogStyles}>
        <Dialog
          open={isOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle style={dialogTitleStyles} id="form-dialog-title">{dialogTitle}</DialogTitle>
          <NinjaInfoForm />
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={() => onAddOrUpdateNinja()} color="primary">
              {dialogTitle}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default connectComponent((state) => {
  const {
    form,
    isOpen,
  } = state.ui.updateNinjas.ninjaDialog;
  const {
    id,
  } = form;
  return {
    id,
    isOpen,
  };
}, {
  onAddOrUpdateNinja: addOrUpdateNinja,
  updateDialogForm: dialogForm,
  closeDialog: dialogClose,
}, DialogAddNinja);



/** WEBPACK FOOTER **
 ** ./src/dashboard/update-ninjas/update-ninjas-dialog/index.js
 **/